/* Berry Daze (14-oct-2026) — utilidades chicas que comparten las secciones.

   data-dz-fit: un título en Best Sugar que NO debe partirse a media palabra
   («Colección», «Hidratación»). Se pone en una sola línea por renglón y se
   le baja la letra de 2 en 2 px hasta que quepa (piso: data-dz-min, 28 px).
   Así un nombre largo nunca ensancha la grilla ni se sale de la pantalla. */
(function () {
  function fit(el) {
    el.style.fontSize = '';
    var min = Number(el.dataset.dzMin) || 28;
    var size = parseFloat(getComputedStyle(el).fontSize);
    var guard = 60;
    while (el.scrollWidth > el.clientWidth + 1 && size > min && guard--) {
      size -= 2;
      el.style.fontSize = size + 'px';
    }
  }
  function all() {
    [].forEach.call(document.querySelectorAll('[data-dz-fit]'), fit);
  }
  window.berryDazeFit = all;
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 120); });
  document.addEventListener('DOMContentLoaded', all);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  document.addEventListener('shopify:section:load', all);
})();

/* 16-oct: upsell del carrito (snippets/berry-cart-upsell.liquid). Agrega la
   berry recomendada y avisa a Horizon con el evento estándar de líneas del
   carrito: el cajón y la burbuja se vuelven a pintar sin recargar. Si no hay
   componente de carrito que escuche, recarga la página. Va delegado en el
   documento porque el cajón cambia su HTML con cada actualización. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-upsell-btn]');
    if (!btn) return;
    var box = btn.closest('[data-bb-upsell]');
    if (!box || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(box.dataset.variant), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!document.querySelector('cart-items-component')) { window.location.reload(); return; }
        var ev = new Event('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add';
        ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
        box.dispatchEvent(ev);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Reintentar'; });
  });
})();
